'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion-weak-memoize.cjs.prod.js");
} else {
  module.exports = require("./emotion-weak-memoize.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/cache/~/@emotion/weak-memoize/dist/emotion-weak-memoize.cjs.js
// module id = 456
// module chunks = 0